import { Component, OnInit, ViewEncapsulation, isDevMode } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService, DataService } from '../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthModel } from '../../../models';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'login',
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})

export class LoginComponent implements OnInit {
    public form: FormGroup;
    public vm: any;

    public estId = '';

    public chipher = '';
    public accountIsEmpty = true;

    constructor(public apiService: ApiService,
        public dataService: DataService,
        private route: ActivatedRoute,
        private router: Router,
        public _fb: FormBuilder) {

        this.route.queryParams.subscribe(qp => {
            if (qp['en'] != undefined) {
                this.chipher = qp['en'];
                this.form = this._fb.group({
                    account: ['                           ', [<any>Validators.required]],
                    dob: ['', [<any>Validators.required]]
                });
            } else if (qp['ac'] != undefined) {
                this.estId = qp['ac'];
                this.chipher = '';
                this.form = this._fb.group({
                    account: ['                           ', [<any>Validators.required]],
                    dob: ['', [<any>Validators.required]]
                });
            } else if (qp['account'] != undefined) {
                this.estId = '';
                this.chipher = '';
                this.accountIsEmpty = false;
                this.form = this._fb.group({
                    account: [qp['account'], [<any>Validators.required]],
                    dob: ['', [<any>Validators.required]]
                });
            } else {
                this.estId = '';
                this.chipher = '';
                this.accountIsEmpty = true;
                this.form = this._fb.group({
                    account: ['', [<any>Validators.required]],
                    dob: ['', [<any>Validators.required]]
                });
            }
            this.setData();

        });
    }

    ngOnInit() {
        if (isDevMode()) {
            let x = new AuthModel('80333', new Date("1970-06-23T00:00:00.000Z"), this.chipher, this.estId);
            this.tryDoAuth(x);
        }
    }

    public setData() {
        this.vm = {
            showInvoiceNotExist: false,
            failedLogin: {
                show: false,
                status: 0,
                updated: new Date()
            },
            signingProccess: false
        }
    }

    public getData(): AuthModel {
        let authModel = new AuthModel(
            this.form.controls["account"].value,
            this.form.controls["dob"].value,
            this.chipher,
            this.estId);
            //new Date(`${this.form.controls["dob"].value.split('/')[2]}-${this.form.controls["dob"].value.split('/')[1]}-${this.form.controls["dob"].value.split('/')[0]}T00:00:00.000Z`));

        return authModel;
    }

    // events
    public signIn() {
        if (this.form.valid) {
            this.vm.signingProccess = true;
            let authModel = this.getData();
            this.tryDoAuth(authModel);
        }
    }

    public resetForm() {
        this.estId = '';
        this.chipher = '';
        this.form.reset();
        this.vm.showInvoiceNotExist = false;
        this.vm.signingProccess = false;
    }

    // api
    public tryDoAuth(authModel: AuthModel) {
        this.apiService.post('/estatements', authModel).subscribe(resp => {
            this.vm.signingProccess = false;
            if (resp.success) {
                this.vm.failedLogin.show = false
                this.vm.showInvoiceNotExist = false;
                this.dataService.serviceData = resp.data;
                this.dataService.authModel = new AuthModel(resp.data.invoice.patient.account, authModel.dob);
                this.router.navigate(['invoice']);
            } else if(resp.error) {
                this.vm.showInvoiceNotExist = false;
                this.vm.failedLogin = {
                    show: true,
                    status: resp.error.status,
                    updated: resp.error.updated
                }
            } else {
                this.vm.failedLogin.show = false;
                this.vm.showInvoiceNotExist = true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/pages/auth/login/login.component.ts